(function () {
  if (!document.querySelector('.cover--bg--anim')) return;

  const COLOR_SEQUENCE = ['#45DEC4', '#52AEFF', '#E5484D', '#FFB224', '#1BCA7C'];

  const OPACITIES = [
    0.02, 0.05, 0.1, 0.12, 0.13, 0.14, 0.16, 0.2, 0.21, 0.22, 0.23, 0.24,
    0.26, 0.28, 0.29, 0.3, 0.33, 0.34, 0.35, 0.36, 0.37, 0.38, 0.39, 0.41,
    0.42, 0.43, 0.45, 0.46, 0.47, 0.48, 0.49, 0.5, 0.51, 0.52, 0.53, 0.55,
    0.56, 0.58, 0.59, 0.6, 0.61, 0.62, 0.63, 0.64, 0.65, 0.66, 0.67, 0.69,
    0.71, 0.73, 0.75, 0.78, 0.79, 0.8, 0.81, 0.83, 0.85, 0.87, 0.88, 0.9,
    0.91, 0.93, 0.97, 0.98, 0.99, 1,
  ];

  const FILL_OPACITIES = [0.9, 0.92, 0.93, 0.94, 0.95, 0.96, 0.97, 0.98, 0.99, 1];

  function rand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function normalizeHexColor(value) {
    if (!value) return '';
    var hex = String(value).trim().toUpperCase();
    if (!hex) return '';
    if (hex.charAt(0) !== '#') hex = '#' + hex;
    return hex;
  }

  function init() {
    var wrapper = document.querySelector('.cover--bg--anim');
    if (!wrapper) return;

    var svg = wrapper.querySelector('svg');
    if (!svg) return;

    var paths = svg.querySelectorAll('path');
    if (!paths.length) return;

    paths.forEach(function (p) {
      p.style.fill = p.getAttribute('fill') || '';
      p.style.fillOpacity = p.getAttribute('fill-opacity') || 1;
      p.style.opacity = p.getAttribute('opacity') || 1;
      p.style.transition = 'fill 1.8s ease, opacity 1.8s ease, fill-opacity 1.8s ease';
    });

    var colorGroups = [];

    paths.forEach(function (p) {
      var initialColor = normalizeHexColor(p.getAttribute('fill') || p.style.fill);
      if (!initialColor) return;
      var group = colorGroups.find(function (g) {
        return g.startColor === initialColor;
      });
      if (!group) {
        group = { startColor: initialColor, paths: [] };
        colorGroups.push(group);
      }
      group.paths.push(p);
    });

    if (!colorGroups.length || !COLOR_SEQUENCE.length) return;

    colorGroups.forEach(function (group) {
      var idx = COLOR_SEQUENCE.indexOf(group.startColor);
      group.baseIndex = idx >= 0 ? idx : 0;
    });

    var intervalId = null;
    var rotationStep = 0;

    function tick() {
      rotationStep = (rotationStep + 1) % COLOR_SEQUENCE.length;

      colorGroups.forEach(function (group) {
        var groupPaths = group.paths;
        if (!groupPaths.length) return;
        var nextColor = COLOR_SEQUENCE[(group.baseIndex + rotationStep) % COLOR_SEQUENCE.length];

        groupPaths.forEach(function (p) {
          p.style.fill = nextColor;
          p.style.fillOpacity = rand(FILL_OPACITIES);
          p.style.opacity = rand(OPACITIES);
        });
      });
    }

    function start() {
      if (intervalId) return;
      intervalId = setInterval(tick, 1500);
    }

    function stop() {
      if (!intervalId) return;
      clearInterval(intervalId);
      intervalId = null;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(wrapper);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ==========================================================================
// WPC – Subnavigation
// ==========================================================================
(function () {
  function initSubnav() {
    var nav = document.querySelector('.wpc__subnavigation');
    if (!nav) return;

    var content = nav.querySelector('.wpc__subnavigation-content');
    if (!content) return;

    var links = content.querySelectorAll('.wpc__subnavigation-link');
    if (!links.length) return;

    // Collect target sections
    var sections = [];
    links.forEach(function (link) {
      var id = link.getAttribute('href').replace('#', '');
      var el = document.getElementById(id);
      if (el) sections.push({ id: id, el: el, link: link });
    });
    if (!sections.length) return;

    var navHeight = nav.offsetHeight;

    // --- Sticky shadow via sentinel ---
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    nav.parentNode.insertBefore(sentinel, nav);

    new IntersectionObserver(function (entries) {
      nav.classList.toggle('is--sticky', !entries[0].isIntersecting);
    }).observe(sentinel);

    // --- Active link tracking ---
    var currentActive = null;

    function setActive(link) {
      if (currentActive === link) return;
      if (currentActive) currentActive.classList.remove('is--active');
      link.classList.add('is--active');
      currentActive = link;

      link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var match = sections.find(function (s) {
              return s.el === entry.target;
            });
            if (match) setActive(match.link);
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    sections.forEach(function (s) {
      sectionObserver.observe(s.el);
    });

    // --- Smooth scroll on click ---
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = this.getAttribute('href').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;

        var offset = navHeight + 16;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubnav);
  } else {
    initSubnav();
  }
})();

// ==========================================================================
// WPC – Packages table sticky offsets
// ==========================================================================
(function () {
  function updatePackagesTableStickyOffsets() {
    var wraps = document.querySelectorAll('.wpc__packages--table-wrap');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var headRow = wrap.querySelector('.wpc__packages--table-head');
      if (!headRow) return;

      var headHeight = Math.ceil(headRow.getBoundingClientRect().height);
      wrap.style.setProperty('--packages-table-head-height', headHeight + 'px');
    });
  }

  function initPackagesTableStickyOffsets() {
    updatePackagesTableStickyOffsets();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updatePackagesTableStickyOffsets, 120);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updatePackagesTableStickyOffsets);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackagesTableStickyOffsets);
  } else {
    initPackagesTableStickyOffsets();
  }
})();

// ==========================================================================
// WPC – Packages table info popovers (hover + HTML5 video controls)
// ==========================================================================
(function () {
  var CLOSE_DELAY_MS = 120;

  function updatePlayButton(video, playBtn) {
    if (!video || !playBtn) return;

    var isPlaying = !video.paused && !video.ended;
    playBtn.classList.toggle('is-playing', isPlaying);
    playBtn.setAttribute('aria-label', isPlaying ? 'Pause' : 'Abspielen');
  }

  function updateMuteButton(video, muteBtn) {
    if (!video || !muteBtn) return;

    muteBtn.classList.toggle('is-muted', video.muted);
    muteBtn.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton stummschalten');
  }

  function ensurePopoverVideoSource(video) {
    if (!video || video.dataset.wpcVideoReady === '1') {
      return;
    }

    var url = video.getAttribute('data-large') || video.getAttribute('data-mobile');
    if (!url) {
      return;
    }

    while (video.firstChild) {
      video.removeChild(video.firstChild);
    }

    var source = document.createElement('source');
    source.className = 'video--source';
    source.src = url;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();
    video.dataset.wpcVideoReady = '1';
  }

  function playPopoverVideo(video) {
    if (!video) return;

    ensurePopoverVideoSource(video);

    if (video.readyState >= 1) {
      video.play().catch(function () {});
      return;
    }

    video.addEventListener('loadeddata', function onLoadedData() {
      video.removeEventListener('loadeddata', onLoadedData);
      video.play().catch(function () {});
    });
  }

  function bindPopoverVideo(video, playBtn, muteBtn) {
    if (!video) return;

    updatePlayButton(video, playBtn);
    updateMuteButton(video, muteBtn);

    if (playBtn) {
      playBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (video.paused || video.ended) {
          playPopoverVideo(video);
        } else {
          video.pause();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        updateMuteButton(video, muteBtn);
      });
    }

    video.addEventListener('play', function () {
      updatePlayButton(video, playBtn);
    });
    video.addEventListener('pause', function () {
      updatePlayButton(video, playBtn);
    });
    video.addEventListener('ended', function () {
      updatePlayButton(video, playBtn);
    });
  }

  function initPackagesTableInfoPopovers() {
    var triggers = document.querySelectorAll('.wpc__packages--table-info');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var popover = trigger.querySelector('.wpc__packages--popover--table');
      var video = trigger.querySelector('[data-wpc-popup-video]');
      var playBtn = trigger.querySelector('.wpc__packages--popover-video-btn--play');
      var muteBtn = trigger.querySelector('.wpc__packages--popover-video-btn--mute');
      var featureCell = trigger.closest('.wpc__packages--table-feature');
      var closeTimer = null;
      var isOpen = false;

      bindPopoverVideo(video, playBtn, muteBtn);

      function setOpenState(open) {
        isOpen = open;
        trigger.classList.toggle('is-open', open);
        if (featureCell) {
          featureCell.classList.toggle('is-popup-open', open);
        }
      }

      function openPopover() {
        clearTimeout(closeTimer);
        if (isOpen) return;

        setOpenState(true);

        if (!video) return;

        playPopoverVideo(video);
      }

      function closePopover() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          setOpenState(false);
          if (video) {
            video.pause();
          }
        }, CLOSE_DELAY_MS);
      }

      trigger.addEventListener('mouseenter', openPopover);
      trigger.addEventListener('mouseleave', closePopover);

      if (popover) {
        popover.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        popover.addEventListener('mouseleave', closePopover);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackagesTableInfoPopovers);
  } else {
    initPackagesTableInfoPopovers();
  }
})();

// ==========================================================================
// WPC – Badges connectors (fixed SVG, dynamic badge placement)
// ==========================================================================
(function () {
  var SVG_BASE_WIDTH = 1174;
  var SVG_BASE_HEIGHT = 321;
  var DESKTOP_BREAKPOINT = 1024;

  function setBadgePositionFromPathEndpoint(wrap, item, path) {
    var endX = parseFloat(path.getAttribute('data-end-x'));
    var endY = parseFloat(path.getAttribute('data-end-y'));
    if (isNaN(endX) || isNaN(endY)) return;

    var wrapRect = wrap.getBoundingClientRect();
    if (!wrapRect.width || !wrapRect.height) return;

    var x = (endX / SVG_BASE_WIDTH) * wrapRect.width;
    var y = (endY / SVG_BASE_HEIGHT) * wrapRect.height;

    item.style.left = x.toFixed(2) + 'px';
    item.style.top = y.toFixed(2) + 'px';
    item.style.transform = 'translate(-50%, -50%)';
  }

  function resetBadgePosition(item) {
    item.style.left = '';
    item.style.top = '';
    item.style.transform = '';
  }

  function updateWrapLayout(wrap) {
    if (!wrap) return;

    var svg = wrap.querySelector('.wpc__badges-connectors');
    if (!svg) return;

    svg.setAttribute('viewBox', '0 0 ' + SVG_BASE_WIDTH + ' ' + SVG_BASE_HEIGHT);

    for (var i = 1; i <= 6; i++) {
      var item = wrap.querySelector('.wpc_badges--item--' + i);
      var path = wrap.querySelector('path[data-badge-line="' + i + '"]');
      if (!item || !path) continue;

      // Keep original SVG geometry untouched (no dynamic path editing).
      var baseD = path.getAttribute('data-base-d') || path.getAttribute('d') || '';
      path.setAttribute('data-base-d', baseD);
      path.setAttribute('d', baseD);

      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        setBadgePositionFromPathEndpoint(wrap, item, path);
      } else {
        resetBadgePosition(item);
      }
    }
  }

  function initBadgeConnectors() {
    var wraps = document.querySelectorAll('.wpc__badges--wrap');
    if (!wraps.length) return;

    var onUpdate = function () {
      wraps.forEach(function (wrap) {
        updateWrapLayout(wrap);
      });
    };

    var resizeTimer = null;
    var onResize = function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onUpdate, 120);
    };

    onUpdate();
    window.addEventListener('resize', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(onUpdate);
    }

    setTimeout(onUpdate, 200);
    setTimeout(onUpdate, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadgeConnectors);
  } else {
    initBadgeConnectors();
  }
})();
